/* TestHelden v2 · Widerrufsbutton § 356a BGB (sections/th-v2-page-widerruf.liquid).
   Schickt die Erklärung an die Plattform (Ticket + Eingangsbestätigung per E-Mail) und zeigt den Eingang
   mit Datum, Uhrzeit, Referenz und Inhalt. Scheitert die Übermittlung, erscheint eine vorausgefüllte E-Mail
   an den Support. Ohne Skript sendet das Formular als Shopify-Kontaktformular.
   Das freiwillige Feld `grund` (Auswahl) geht als Schlüssel mit; die Plattform ignoriert es bis Phase 1. */
(function () {
  'use strict';

  var FELDER = [
    ['name', 'Name'],
    ['email', 'E-Mail für die Bestätigung'],
    ['bestellnummer', 'Bestellnummer'],
    ['bestelldatum', 'Bestellt am'],
    ['produkt', 'Produkt'],
    ['nachricht', 'Nachricht']
  ];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function q(root, sel) { return root.querySelector(sel); }

  function werte(form) {
    var w = {};
    form.querySelectorAll('[data-th-v2-wid-feld]').forEach(function (el) {
      w[el.getAttribute('data-th-v2-wid-feld')] = (el.value || '').trim();
    });
    return w;
  }

  function feldFehler(form, name, text) {
    var el = q(form, '[data-th-v2-wid-feld="' + name + '"]');
    if (!el) return;
    var box = document.getElementById(el.id + '-fehler');
    if (text) {
      el.setAttribute('aria-invalid', 'true');
      if (box) { q(box, '[data-th-v2-wid-fehler]').textContent = text; box.hidden = false; }
    } else {
      el.removeAttribute('aria-invalid');
      if (box) box.hidden = true;
    }
  }

  function zeigeFehler(form, fehler) {
    ['name', 'email', 'bestellnummer'].forEach(function (n) { feldFehler(form, n, fehler[n] || ''); });
    var summary = q(form, '[data-th-v2-wid-summary]');
    var liste = q(form, '[data-th-v2-wid-summary-liste]');
    var keys = Object.keys(fehler);
    liste.innerHTML = '';
    keys.forEach(function (k) {
      var li = document.createElement('li');
      var el = q(form, '[data-th-v2-wid-feld="' + k + '"]');
      if (el) {
        var a = document.createElement('a');
        a.href = '#' + el.id;
        a.textContent = fehler[k];
        li.appendChild(a);
      } else {
        li.textContent = fehler[k];
      }
      liste.appendChild(li);
    });
    summary.hidden = keys.length === 0;
    if (keys.length) summary.focus();
  }

  /* Bestellnummern (Tom 19.10.): Shopify „TH-1025“ (mit/ohne #, Groß-/Kleinschreibung egal) und
     Woo-Nummern (woo_orders: 5 bis 6 Ziffern, 13902 bis 439937; zugelassen 4 bis 7 Ziffern).
     App-Käufe: Apple-Order-ID = M + 9 bis 11 Zeichen (10 bis 12 gesamt), Google Play = „GPA.…“. */
  var NR_SHOPIFY = /^#?TH[-\s]?\d{4,7}$/i;
  var NR_WOO = /^#?\d{4,7}$/;
  var NR_APPLE = /^M[A-Z0-9]{9,11}$/i;
  var NR_GOOGLE = /^GPA\./i;
  var MELDUNG_FORMAT = 'Bitte prüfe die Bestellnummer. Deine Bestellnummer findest du in der Bestellbestätigung, z. B. TH-1234.';
  var MELDUNG_LEER = 'Bitte gib die Bestellnummer an. Hast du keine, wähle „Ich habe keine Bestellnummer“ und nenne das Produkt.';
  var MELDUNG_IAP = 'Diese Nummer gehört zu einem App-Kauf. Die Erstattung beantragst du direkt bei Apple bzw. Google.';

  function iapArt(nr) {
    var n = (nr || '').replace(/\s+/g, '');
    if (NR_GOOGLE.test(n)) return 'google';
    if (NR_APPLE.test(n)) return 'apple';
    return '';
  }

  function nrGueltig(nr) {
    var n = (nr || '').trim();
    return NR_SHOPIFY.test(n) || NR_WOO.test(n);
  }

  function pruefe(w) {
    var f = {};
    if (w.name.length < 2) f.name = 'Bitte gib deinen Namen an.';
    if (!EMAIL_RE.test(w.email)) f.email = 'Bitte gib eine gültige E-Mail-Adresse an.';
    if (!w.bestellnummer && !w.produkt) f.bestellnummer = MELDUNG_LEER;
    else if (w.bestellnummer && iapArt(w.bestellnummer)) f.bestellnummer = MELDUNG_IAP;
    else if (w.bestellnummer && !nrGueltig(w.bestellnummer)) f.bestellnummer = MELDUNG_FORMAT;
    return f;
  }

  /* App-Kauf erkannt: Hinweis am Feld zeigen, Absenden sperren (Knopf deaktiviert + Sperrhinweis). */
  function setzeIap(form, art) {
    var bereich = q(form, '[data-th-v2-wid-iap-bereich]');
    if (bereich) {
      bereich.querySelectorAll('[data-th-v2-wid-iap]').forEach(function (box) {
        box.hidden = box.getAttribute('data-th-v2-wid-iap') !== art;
      });
      bereich.classList.toggle('is-aktiv', !!art);
    }
    var knopf = q(form, '[data-th-v2-wid-senden]');
    if (knopf) knopf.disabled = !!art;
    var sperre = q(form, '[data-th-v2-wid-sperre]');
    if (sperre) sperre.hidden = !art;
    form.__thV2WidIap = art || '';
  }

  /* „Ich habe keine Bestellnummer“: Produktfeld einblenden. Ohne Skript ist es immer sichtbar. */
  function initOhneNummer(form) {
    var zeile = q(form, '[data-th-v2-wid-ohne-nr-zeile]');
    var knopf = q(form, '[data-th-v2-wid-ohne-nr]');
    var feld = q(form, '[data-th-v2-wid-produkt-feld]');
    var eingabe = q(form, '[data-th-v2-wid-feld="produkt"]');
    if (!zeile || !knopf || !feld || !eingabe) return;
    if (eingabe.value.trim()) return; // schon ausgefüllt (z. B. Zurück-Taste): sichtbar lassen
    feld.hidden = true;
    zeile.hidden = false;
    knopf.addEventListener('click', function () {
      feld.hidden = false;
      knopf.setAttribute('aria-expanded', 'true');
      zeile.hidden = true;
      eingabe.focus();
    });
  }

  /* Live-Prüfung der Bestellnummer: App-Käufe sofort, Formatfehler beim Verlassen des Felds. */
  function initBestellnummer(form) {
    var el = q(form, '[data-th-v2-wid-feld="bestellnummer"]');
    if (!el) return;
    function aktualisiere(mitFormat) {
      var wert = el.value.trim();
      var art = iapArt(wert);
      setzeIap(form, art);
      var produkt = (q(form, '[data-th-v2-wid-feld="produkt"]') || {}).value || '';
      var sichtbar = el.getAttribute('aria-invalid') === 'true';
      if (!wert) {
        if (sichtbar && produkt.trim()) feldFehler(form, 'bestellnummer', '');
        else if (sichtbar) feldFehler(form, 'bestellnummer', MELDUNG_LEER);
      } else if (art || nrGueltig(wert)) {
        feldFehler(form, 'bestellnummer', '');
      } else if (mitFormat || sichtbar) {
        feldFehler(form, 'bestellnummer', MELDUNG_FORMAT);
      }
    }
    el.addEventListener('input', function () { aktualisiere(false); });
    el.addEventListener('change', function () { aktualisiere(true); });
    if (el.value.trim()) aktualisiere(true);
  }

  function erklaerung(w) {
    var zeilen = [['Erklärung', 'Hiermit widerrufe ich den von mir abgeschlossenen Vertrag.']];
    FELDER.forEach(function (f) { if (w[f[0]]) zeilen.push([f[1], w[f[0]]]); });
    return zeilen;
  }

  function fuelleInhalt(dl, w) {
    dl.innerHTML = '';
    erklaerung(w).forEach(function (z) {
      var dt = document.createElement('dt'); dt.textContent = z[0];
      var dd = document.createElement('dd'); dd.textContent = z[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
  }

  /* Freiwilliger Grund: als Schlüssel (`grund`, z. B. doppelt, buch) an die Plattform, im Mailtext lesbar.
     Er gehört nicht zur Widerrufserklärung und erscheint deshalb nicht in „Inhalt deiner Erklärung“. */
  function grundText(form) {
    var el = q(form, '[data-th-v2-wid-feld="grund"]');
    if (!el || !el.value || el.selectedIndex < 0) return '';
    return (el.options[el.selectedIndex].text || '').trim();
  }

  function jetztLesbar() {
    try {
      var d = new Date();
      var datum = d.toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit', year: 'numeric' });
      var zeit = d.toLocaleTimeString('de-DE', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' });
      return datum + ' um ' + zeit + ' Uhr';
    } catch (e) { return new Date().toString(); }
  }

  function ausweich(sektion, form, w) {
    var box = q(sektion, '[data-th-v2-wid-ausweich]');
    var link = q(sektion, '[data-th-v2-wid-mailto]');
    var adresse = (link.getAttribute('href') || '').replace(/^mailto:/, '').split('?')[0];
    var grund = grundText(form);
    var text = erklaerung(w).map(function (z) { return z[0] + ': ' + z[1]; }).join('\n')
      + (grund ? '\nGrund (freiwillig): ' + grund : '')
      + '\n\nZeitpunkt: ' + jetztLesbar();
    var betreff = 'Widerruf' + (w.bestellnummer ? ' Bestellung ' + w.bestellnummer : '');
    link.setAttribute('href', 'mailto:' + adresse + '?subject=' + encodeURIComponent(betreff) + '&body=' + encodeURIComponent(text));
    box.hidden = false;
    var fokus = q(box, '[data-th-v2-wid-ausweich-box]');
    if (fokus) fokus.focus();
  }

  function erfolg(sektion, form, w, antwort) {
    var box = q(sektion, '[data-th-v2-wid-erfolg]');
    q(box, '[data-th-v2-wid-eingang]').textContent = antwort.eingangLesbar || jetztLesbar();
    q(box, '[data-th-v2-wid-referenz]').textContent = antwort.referenz || '';
    q(box, '[data-th-v2-wid-mail]').textContent = w.email;
    q(box, '[data-th-v2-wid-mail-ok]').hidden = !antwort.bestaetigungGesendet;
    q(box, '[data-th-v2-wid-mail-fehlt]').hidden = !!antwort.bestaetigungGesendet;
    fuelleInhalt(q(box, '[data-th-v2-wid-inhalt]'), w);
    form.hidden = true;
    box.hidden = false;
    q(sektion, '[data-th-v2-wid-ausweich]').hidden = true;
    var fokus = q(box, '[data-th-v2-wid-erfolg-box]');
    if (fokus) { fokus.focus(); fokus.scrollIntoView({ block: 'start' }); }
  }

  function init(form) {
    if (form.__thV2Wid) return;
    form.__thV2Wid = true;
    var endpunkt = form.getAttribute('data-th-v2-widerruf');
    var sektion = form.closest('.th-card__body') || form.parentNode;
    var knopf = q(form, '[data-th-v2-wid-senden]');
    var drucken = q(sektion, '[data-th-v2-wid-drucken]');
    if (drucken) drucken.addEventListener('click', function () { window.print(); });
    initOhneNummer(form);
    initBestellnummer(form);
    if (!endpunkt || !window.fetch) return; // Rückfall: natives Kontaktformular

    /*
     * Shopify-Captcha für Kontaktformulare (storefront-forms-hcaptcha) bindet sich beim ersten
     * Tippen ans Formular und schickt es nach unserem Versand ein zweites Mal NATIV ab
     * (form.submit()) → Kunde landet auf /challenge statt auf der Eingangsbestätigung
     * (Befund 19.10.2026, Widerruf 2.0). Mit JavaScript läuft der Widerruf ausschließlich
     * über die Plattform: Absenden zuerst abfangen (Capture auf window) und den nativen
     * Versand dieses Formulars stilllegen. Ohne JavaScript bleibt das Kontaktformular.
     */
    form.submit = function () {};
    window.addEventListener('submit', function (ev) {
      if (ev.target !== form) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      form.dispatchEvent(new CustomEvent('th-v2-wid-senden'));
    }, true);

    var laeuft = false;
    form.addEventListener('th-v2-wid-senden', function (ev) {
      if (laeuft) return;
      var w = werte(form);
      var fehler = pruefe(w);
      zeigeFehler(form, fehler);
      if (Object.keys(fehler).length) return;

      laeuft = true;
      knopf.classList.add('is-loading');
      knopf.setAttribute('aria-disabled', 'true');
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? window.setTimeout(function () { ctrl.abort(); }, 25000) : null;

      var daten = {};
      Object.keys(w).forEach(function (k) { daten[k] = w[k]; });
      daten.quelle = window.location.href;

      fetch(endpunkt, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(daten),
        signal: ctrl ? ctrl.signal : undefined,
        credentials: 'omit'
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j }; }); })
        .then(function (res) {
          if (res.status === 200 && res.j && res.j.ok) { erfolg(sektion, form, w, res.j); return; }
          if (res.status === 422 && res.j && (res.j.iap === 'apple' || res.j.iap === 'google')) {
            // Server erkennt einen App-Kauf (künftige Plattform-Antwort): derselbe Hinweis wie bei der Live-Prüfung.
            zeigeFehler(form, {});
            setzeIap(form, res.j.iap);
            var box = q(form, '[data-th-v2-wid-iap="' + res.j.iap + '"]');
            if (box) box.scrollIntoView({ block: 'center' });
            var nr = q(form, '[data-th-v2-wid-feld="bestellnummer"]');
            if (nr) nr.focus();
            return;
          }
          if (res.status === 422 && res.j && res.j.fehler) { zeigeFehler(form, res.j.fehler); return; }
          ausweich(sektion, form, w);
        })
        .catch(function () { ausweich(sektion, form, w); })
        .then(function () {
          if (timer) window.clearTimeout(timer);
          laeuft = false;
          knopf.classList.remove('is-loading');
          knopf.removeAttribute('aria-disabled');
        });
    });
  }

  function start(root) {
    (root || document).querySelectorAll('form[data-th-v2-widerruf]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();
  document.addEventListener('shopify:section:load', function (ev) { start(ev.target); });
})();
